import styled from 'styled-components';
import Icon from 'antd/lib/icon';

export const StyledIcon = styled(Icon)`
  margin-right: 5px;
`;

export const StyledDropdownTrigger = styled(Icon)`
  margin-left: 0.35rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
`;
